"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceActionAlt = exports.ResourceAction = exports.ResourceSource = exports.ResourceActions = exports.ResourceFooter = exports.ResourceContent = exports.ResourceType = exports.ResourceHeader = exports.ResourceBody = exports.Resource = void 0;
const React = require("react");
const Button_1 = require("../Button");
// css
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const Cell_1 = require("../../structure/Cell");
const standardSizes_1 = require("../../../../types/standardSizes");
const Avatar_1 = require("../Avatar");
const useElementDimension_1 = require("../../../../hooks/useElementDimension");
const css = (0, cssComposer_1.default)(styles, "Resource");
const Resource = ({ children, fillContainer }) => {
    return (React.createElement("div", { className: css("", { "-fillContainer": fillContainer }) }, children));
};
exports.Resource = Resource;
const ResourceBody = ({ children, onViewMoreContent }) => {
    const [containerRef, { height: containerHeight }] = (0, useElementDimension_1.useElementDimension)();
    const [childRef, { height: childHeight }] = (0, useElementDimension_1.useElementDimension)();
    const isOverlowing = containerHeight < childHeight;
    return (React.createElement("div", { className: css("body", "section"), ref: containerRef },
        React.createElement("div", { ref: childRef }, children),
        isOverlowing && (React.createElement("div", { className: css("preview") }, onViewMoreContent && (React.createElement(Button_1.AltButton, { size: standardSizes_1.TStandardSizes.Small, onClick: onViewMoreContent }, "See more"))))));
};
exports.ResourceBody = ResourceBody;
const ResourceHeader = ({ children, icon, action }) => {
    return (React.createElement("div", { className: css("header", "section"), "data-test": "resource-header" },
        React.createElement(Cell_1.Cell, { decorationIcon: icon }, children),
        action && (React.createElement("div", { className: css("header_action"), "data-test": "resource-header-action" },
            React.createElement(Button_1.Button, { onClick: action.onClick }, action.label || "Edit")))));
};
exports.ResourceHeader = ResourceHeader;
const ResourceType = ({ children }) => {
    return React.createElement("div", { className: css("type") }, children);
};
exports.ResourceType = ResourceType;
const ResourceContent = ({ children }) => {
    return React.createElement("div", { className: css("content", "section") }, children);
};
exports.ResourceContent = ResourceContent;
const ResourceFooter = ({ children, action }) => {
    return (React.createElement("div", { className: css("footer", "section"), "data-test": "resource-footer" },
        React.Children.count(children) > 0 && (React.createElement("div", { className: css("footer_content") }, children)),
        action && (React.createElement("div", { className: css("footer_action"), "data-test": "resource-footer-action" },
            React.createElement(exports.ResourceActionAlt, { onClick: action.onClick }, action.label || "See more")))));
};
exports.ResourceFooter = ResourceFooter;
const ResourceActions = ({ children }) => {
    return (React.createElement("div", { className: css("actions", "section"), "data-test": "resource-actions" }, React.Children.map(children, (child, index) => (React.createElement("div", { className: css("actions_item"), "data-test": `resource-action-${index}` }, child)))));
};
exports.ResourceActions = ResourceActions;
const ResourceSource = ({ imageSrc, title, description }) => {
    const showContent = Boolean(title) || Boolean(description);
    return (React.createElement("div", { className: css("source", "section") },
        Boolean(imageSrc) && (React.createElement("div", { className: css("source_decoration") },
            React.createElement(Avatar_1.default, { src: imageSrc, stdSize: standardSizes_1.TStandardSizes.ExtraSmall }))),
        showContent && (React.createElement("div", { className: css("source_content") },
            Boolean(title) && React.createElement("h5", null, title),
            Boolean(description) && (React.createElement(Cell_1.CellDescription, null, description))))));
};
exports.ResourceSource = ResourceSource;
const ResourceAction = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (React.createElement(Button_1.Button, Object.assign({ size: standardSizes_1.TStandardSizes.Small }, rest), children));
};
exports.ResourceAction = ResourceAction;
const ResourceActionAlt = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (React.createElement(Button_1.AltButton, Object.assign({ size: standardSizes_1.TStandardSizes.Small }, rest), children));
};
exports.ResourceActionAlt = ResourceActionAlt;
//# sourceMappingURL=index.js.map